import React, { useState } from 'react';
import { Select } from 'antd';
import { debounce } from 'lodash';

interface CopyrightSelectProp {
  optionData: any;
  mode?: 'multiple' | 'tags';
}
export const CopyrightSelect = (props: CopyrightSelectProp) => {
  const [searchOrganizationName, setSearchOrganizationName] = useState<string>(
    ''
  );
  const { optionData } = props;

  const searchOrganization = debounce((value: string) => {
    setSearchOrganizationName(value);
  }, 500);
  return (
    <Select
      {...props}
      showSearch={true}
      optionFilterProp={'children'}
      placeholder="请选择机构"
      onSearch={value => searchOrganization(value)}>
      {(optionData || []).map((item: any, index: number) => (
        <Select.Option
          key={index + 'organization'}
          value={parseInt(item.uuid, 10)}
          style={{
            display:
              index > 19 &&
              (searchOrganizationName === '' ||
                item.value.search(searchOrganizationName) === -1) &&
              'none',
          }}>
          {item.value}
        </Select.Option>
      ))}
    </Select>
  );
};
